import { Fragment } from 'react';
import './index.css';
function HelpSMPage() {
    return <Fragment >
        <div className="help-sm-page">
            <div className="content mb-0">
                <img src="assets/img/sm/1.png" alt="" />
                <img className="mv-4" src="assets/img/sm/2.png" alt="" />
                <a href="https://ux-cdn.cencosudx.io/milocal/pdf/alertas-found-rate-sm.pdf" target="_blank">
                    <img className='card' src="assets/img/sm/3.png" alt="" />
                </a>
                <a href="https://ux-cdn.cencosudx.io/milocal/pdf/recepcion-mercaderia-subgerente-sm.pdf" target="_blank">
                    <img className='card' src="assets/img/sm/4.png" alt="" />
                </a>
                <img className="mv-6" src="assets/img/sm/5.png" alt="" />
                <img src="assets/img/sm/6.png" alt="" />
            </div>
        </div>

    </Fragment>

}

export default HelpSMPage;
